export default __webpack_public_path__ + "media/images/slider-left-arrow-b818d2a631ceeee7e9a6515df3b5d2ca.svg";